import { render, staticRenderFns } from "./EditDppOfferComponent.vue?vue&type=template&id=4d8b4297&"
import script from "./EditDppOfferComponent.vue?vue&type=script&lang=js&"
export * from "./EditDppOfferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports